import PropTypes from 'prop-types';
import { FaEdit, FaTrash, FaEye } from 'react-icons/fa';
import FullViewAdminTableModal from './FullViewAdminTableModal';
import { useState } from 'react';


const AdminNewsTable = ({ news, onEdit, onDelete, onBulkDelete, isLoading, hasMore, loadMore, selectedIds, onSelect, onSelectAll }) => {
  const truncateContent = (text) => {
    if (!text) return 'No content';
    const words = text.split(/\s+/);
    return words.length > 30 ? words.slice(0, 30).join(' ') + '...' : text;
  };

  const [selectedItem, setSelectedItem] = useState(null);




  return (
    <div className="w-full">
      <div className="mb-4 flex justify-end">
        {selectedIds.length > 0 && (
          <button
            onClick={() => onBulkDelete(selectedIds)}
            className="px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700 flex items-center"
          >
            <FaTrash className="mr-2" /> Delete Selected ({selectedIds.length})
          </button>
        )}
      </div>
      <table className="w-full bg-white border table-fixed">
        <thead>
          <tr>
            <th className="py-2 px-4 border text-center w-12">
              <input
                type="checkbox"
                checked={selectedIds.length === news.length && news.length > 0}
                onChange={onSelectAll}
              />
            </th>
            <th className="py-2 px-4 border text-left w-16">ID</th>
            <th className="py-2 px-4 border text-left w-44">Title</th>
            <th className="py-2 px-4 border text-left w-20">Category</th>
            <th className="py-2 px-4 border text-left w-[150px]">Content</th>
            <th className="py-2 px-4 border text-left w-[150px]">Descriptions</th>
            <th className="py-2 px-4 border text-left w-28">News Field</th>
            <th className="py-2 px-4 border text-left w-20">Date</th>
            <th className="py-2 px-4 border text-center w-48">Actions</th>
          </tr>
        </thead>
        <tbody>
          {news.map((item) => (
            <tr key={item.id}>
              <td className="py-2 px-4 border text-center">
                <input
                  type="checkbox"
                  checked={selectedIds.includes(item.id)}
                  onChange={() => onSelect(item.id)}
                />
              </td>
              <td className="py-2 px-4 border">{item.id}</td>
              <td className="py-2 px-4 border">{item.title}</td>
              <td className="py-2 px-4 border capitalize">{item.category}</td>
              <td className="py-2 px-4 border capitalize">
                {truncateContent(item.content)}
              </td>
              <td className="py-2 px-4 border capitalize max-w-xs" title={item.descriptions}>
                {truncateContent(item.descriptions)}
              </td>

              <td className="py-2 px-4 border capitalize">{item.news_field}</td>
              <td className="py-2 px-4 border">
                {item.date ? new Date(item.date).toLocaleDateString() : 'Unknown date'}
              </td>

              <td className="py-2 px-4 border">
                <div className="flex flex-wrap justify-center items-center">
                  <button
                    onClick={() => setSelectedItem(item)}
                    className="m-1 px-3 py-1 bg-green-600 text-white rounded flex items-center"
                  >
                    <FaEye size={20} className="mr-1" />
                  </button>
                  <button
                    onClick={() => onEdit(item)}
                    className="m-1 px-3 py-1 bg-blue-500 text-white rounded flex items-center"
                  >
                    <FaEdit size={20} className="mr-1" />
                  </button>
                  <button
                    onClick={() => onDelete(item.id)}
                    className="m-1 px-3 py-1 bg-red-600 text-white rounded flex items-center"
                  >
                    <FaTrash size={20} className="mr-1" />
                  </button>
                </div>
              </td>


            </tr>
          ))}
        </tbody>
      </table>

      <div className="text-center mt-4">
        {isLoading && news.length > 0 && (
          <p className="text-gray-500">Loading more...</p>
        )}
        {hasMore && !isLoading && news.length > 0 && (
          <button
            onClick={loadMore}
            className="px-6 py-3 bg-gradient-to-r from-blue-500 to-indigo-600 hover:from-blue-200 hover:to-indigo-400 hover:text-gray-500 text-white text-2xl font-semibold rounded-2xl shadow-2xl hover:shadow-3xl  transition-all duration-300 relative"
          >
            Load More
          </button>
        )}
        {!hasMore && news.length > 0 && (
          <p className="text-gray-500">No more articles to load</p>
        )}
        {news.length === 0 && (
          <p className="text-gray-500">No articles available</p>
        )}
      </div>
      <FullViewAdminTableModal item={selectedItem} onClose={() => setSelectedItem(null)} />
    </div>
  );
};

AdminNewsTable.propTypes = {
  news: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      title: PropTypes.string.isRequired,
      category: PropTypes.string,
      content: PropTypes.string,
      news_field: PropTypes.string,
      date: PropTypes.string,
      photo_url: PropTypes.string,
    })
  ).isRequired,
  onEdit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  onBulkDelete: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
  hasMore: PropTypes.bool,
  loadMore: PropTypes.func,
  selectedIds: PropTypes.arrayOf(PropTypes.number).isRequired,
  onSelect: PropTypes.func.isRequired,
  onSelectAll: PropTypes.func.isRequired,
};

export default AdminNewsTable;